var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0916 2.00989L11.4622 3.63927L9.83119 2.00989C9.30349 1.46409 8.6724 1.02881 7.97472 0.729435C7.27705 0.430063 6.52675 0.272588 5.76759 0.266191C5.00842 0.259794 4.25558 0.404601 3.55296 0.692174C2.85034 0.979747 2.212 1.40433 1.67517 1.94116C1.13834 2.47799 0.713759 3.11633 0.426186 3.81895C0.138614 4.52157 -0.00619409 5.27441 0.000203067 6.03358C0.00660022 6.79274 0.164075 7.54304 0.463447 8.24071C0.762819 8.93838 1.1981 9.56948 1.7439 10.0972L3.37328 11.7266L11.4606 19.8155L19.5495 11.7199L21.1773 10.0906C21.7398 9.56698 22.191 8.93542 22.5041 8.23356C22.8171 7.53171 22.9854 6.77398 22.9991 6.00561C23.0128 5.23724 22.8714 4.47401 22.5835 3.76147C22.2957 3.04894 21.8672 2.40173 21.3236 1.8585C20.78 1.31526 20.1325 0.887141 19.4198 0.599703C18.7071 0.312265 17.9438 0.171407 17.1754 0.185537C16.4071 0.199668 15.6495 0.368498 14.9478 0.681946C14.2461 0.995395 13.6148 1.44703 13.0916 2.00989Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.85b06fb05a69b56ff43648dfc6d5f90c.svg";
export { ForwardRef as ReactComponent };